import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { Buffer } from "buffer";
import uniqid from "uniqid";

import Warning from "../../assets/icon/warning.svg";
import { useJwt } from "../../contexts/jwtContext";
import { useUser } from "../../contexts/userContext";

const LoginPage = () => {
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  // const [errorMessage, setErrorMessage] = useState('');
  const [errorMessages, setErrorMessages] = useState([]);
  const { jwt, setJwt } = useJwt();
  const { setUser } = useUser();

  const onChangeUserName = (e) => {
    setUserName(e.target.value);
  };

  const onChangePassword = (e) => {
    setPassword(e.target.value);
  };

  // return a JSON object of token's payload
  const decodeJwt = (token) => {
    return JSON.parse(Buffer.from(token.split(".")[1], "base64").toString());
  };

  const login = async () => {
    const headers = {
      "Content-Type": "application/json",
    };
    const formData = { userName, password };
    fetch(`${process.env.REACT_APP_BACKEND_HOST}/api/login`, {
      method: "POST",
      mode: "cors",
      headers,
      body: JSON.stringify(formData),
    })
      .then(async (res) => {
        const json = await res.json();
        json.status = res.status;
        return json;
      })
      .then((res) => {
        if (res.status === 200) {
          setJwt(res.token);

          // set user context
          const decodedToken = decodeJwt(res.token);
          const user = {
            displayName: res.displayName,
            adminId: decodedToken.adminId,
          };
          setUser(user);

          // save data into sessionStorage
          sessionStorage.setItem("jwt", res.token);
          sessionStorage.setItem("user", JSON.stringify(user));
        } else if (res.status === 400) {
          console.log(res);
          if (res.errors) {
            setErrorMessages(res.errors.map((err) => err.msg));
          } else if (res.msg) {
            console.log([res.msg]);
            setErrorMessages([res.msg]);
          }
        }
        return true;
      });
  };

  const isExpired = (token) => {
    return true; // always force to re-login
  };

  // if authenticated, navigate to reservation management
  if (jwt !== "" && jwt !== undefined) {
    return <Navigate to="/reservations" />;
  } else {
    return (
      <div className="min-h-screen w-screen">
        <div className=" w-fit h-fit absolute inset-0 m-auto grid justify-items-center gap-y-4 ">
          {/* background image */}
          <div className="bg-logo bg-contain bg-no-repeat bg-center h-full w-full absolute z-[-1] opacity-20 brightness-75" />

          <h1 className="text-6xl font-bold font-chinese text-title text-center align-self-end">
            {process.env.REACT_APP_TITLE}
          </h1>
          <input
            onChange={onChangeUserName}
            className="opacity-75 bg-white border-2 border-border-gray w-96 h-[3.5rem] rounded pl-4"
            type="text"
            placeholder="帳號"
          />
          <input
            onChange={onChangePassword}
            className="opacity-75 bg-white border-2 border-border-gray w-96 h-[3.5rem] rounded pl-4 "
            type="password"
            placeholder="密碼"
          />
          {errorMessages.length === 0 ? (
            <></>
          ) : (
            <div className="flex align-items-center gap-x-2">
              <img src={Warning} className="w-8 h-8" />
              <p className="text-red-600 font-chinese text-lg">
                {errorMessages.map((message, index) => (
                  <span
                    key={uniqid()}
                  >{`${index === 0 ? "" : ","} ${message}`}</span>
                ))}
              </p>
            </div>
          )}
          <button
            onClick={login}
            className="bg-custom-orange hover:brightness-75 w-28 h-[2.5rem] rounded text-white font-bold text-xl mt-4"
          >
            登入
          </button>
        </div>
      </div>
    );
  }
};

export default LoginPage;
